import { Card } from '@tribeplatform/react-ui-kit/Card'

import { BC } from '../../types/index.js'
import { CardFooterProps } from './types.js'

export const CardFooterBlock: BC<CardFooterProps> = Card.Footer
